<template>
  <h4>Tools</h4>
  <z-tabs v-model="currentTab" :tabs="tabs" @change="setTab" />
  <div class="custom-wrapper">
    <div v-if="currentTab === 'VIN Search'">
      <find-vin />
    </div>
  </div>
</template>
<script>
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import FindVin from '@/components/tools/FindVin.vue'
export default {
  name: 'ToolsHost',
  components: {
    ZTabs,
    FindVin
  },
  data() {
    return {
      currentTab: 'VIN Search'
    }
  },
  mounted() {
    this.setTab('VIN Search')
  },
  computed: {
    tabs() {
      let _tabs = ['VIN Search']
      return _tabs
    }
  },
  methods: {
    async setTab(value) {
      this.currentTab = value
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 700px;
  height: 700px;
}
</style>
